
import { inventarioApi } from "../../apis";
import { useInventarioStore } from "../../stores/ui/inventario.store";

import Swal from "sweetalert2";




export const inventarioXID = async (id) => {
    try {
        const { data } = await inventarioApi.get(`/xid/${id}`);
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}




export const listadoInventarioTodo = async ({ page, termino }) => {
    try {
        const params = new URLSearchParams();
        params.append('page',  page.toString());
        params.append('termino',  termino);

        const { data } = await inventarioApi.get('/todos', { params });
        useInventarioStore.setState({ totalInventario : data.total });
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}





export const listadoInventarioSelect = async () => {
    try {
        const { data } = await inventarioApi.get('/select/todos');
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}







export const listadoInventarioXProveedor = async (id) => {
    try {
        const { data } = await inventarioApi.get(`/xproveedor/${id}`);
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}



export const crearNuevoInventario = async (body) => {
    try {
        let data = (body.id)
        ?   await inventarioApi.put(`/${body.id}`, body)
        :   await inventarioApi.post('/new', body);
        Swal.fire('Exitoso', data.data.msg, 'success');
        return true;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}